"use client";

import React, { useState, useMemo } from "react";
import { FAQ_DATA, FAQ } from "./faq-data";

interface FAQStaticProps {
  category?: FAQ['category'];
  limit?: number;
  className?: string;
  // Allow custom filtering
  filter?: (faq: FAQ) => boolean;
  // Allow custom FAQ data (useful for page-specific FAQs)
  customFAQs?: FAQ[];
}

const FAQStatic: React.FC<FAQStaticProps> = ({ 
  category, 
  limit, 
  className = "",
  filter,
  customFAQs
}) => {
  const [openId, setOpenId] = useState<string | null>(null);

  const faqs = useMemo(() => {
    let data = customFAQs || FAQ_DATA;
    
    // Apply category filter
    if (category) {
      data = data.filter(faq => faq.category === category);
    }
    
    // Apply custom filter
    if (filter) {
      data = data.filter(filter);
    }
    
    // Sort by display order
    data.sort((a, b) => a.displayOrder - b.displayOrder);
    
    // Apply limit
    if (limit && limit > 0) {
      data = data.slice(0, limit);
    }
    
    return data;
  }, [category, limit, filter, customFAQs]);

  if (faqs.length === 0) {
    return null;
  }

  const handleToggle = (faqId: string) => {
    setOpenId(openId === faqId ? null : faqId);
  };

  return (
    <div className={`space-y-4 ${className}`}>
      {faqs.map((faq) => (
        <div key={faq.id} className="collapse collapse-arrow bg-base-200">
          <input 
            type="radio" 
            name="faq-accordion"
            checked={openId === faq.id}
            onChange={() => handleToggle(faq.id)}
          />
          <div className="collapse-title text-lg font-medium">
            {faq.question}
          </div>
          <div className="collapse-content">
            <p className="whitespace-pre-line">{faq.answer}</p>
          </div>
        </div>
      ))}
    </div>
  );
};

export default FAQStatic;